module.exports = __webpack_public_path__ + "img/sharp11-1.23ffe542.png";